function PaymentPolicy() {
  return (
    <>
      <section className="page-header text-center text-white">
        <div className="container">
          <h1 className="fw-bold">Payment Policy</h1>
          <p className="mb-0 opacity-75">Last updated: June 2025</p>
        </div>
      </section>

      <section className="py-5">
        <div className="container policy-content">
          <h4>1. Fee Structure</h4>
          <p>Course fees vary based on the program selected. Detailed fee structures are available on individual course pages or can be obtained by contacting our admissions team.</p>

          <h4>2. Accepted Payment Methods</h4>
          <ul>
            <li>UPI (Google Pay, PhonePe, Paytm, etc.)</li>
            <li>Debit/Credit Cards (Visa, Mastercard, RuPay)</li>
            <li>Net Banking</li>
            <li>Bank Transfer (NEFT/RTGS/IMPS)</li>
            <li>EMI options (available on select cards)</li>
            <li>Demand Draft / Cheque (payable to "Garvit Education")</li>
          </ul>

          <h4>3. Payment Schedule</h4>
          <ul>
            <li><strong>Full Payment:</strong> Complete fee payment at the time of enrollment.</li>
            <li><strong>Installment Plan:</strong> Available for select programs. Students may pay in 2–4 installments as per the schedule provided at admission.</li>
            <li><strong>Late Payment:</strong> A late fee of ₹500 per week will be charged for overdue installments.</li>
          </ul>

          <h4>4. Payment Confirmation</h4>
          <p>Upon successful payment, a confirmation receipt will be sent to your registered email address. Please retain all payment receipts for your records.</p>

          <h4>5. Failed Transactions</h4>
          <p>If a payment fails but the amount is debited from your account, it will be automatically refunded within 5–7 business days by your bank. If not, contact us with the transaction details.</p>

          <h4>6. Fee Revision</h4>
          <p>Garvit Education reserves the right to revise fee structures. Any revision will not affect students who have already enrolled and paid for the current academic session.</p>

          <h4>7. Financial Assistance</h4>
          <ul>
            <li>Scholarships available for meritorious students</li>
            <li>Need-based financial aid on case-by-case basis</li>
            <li>Education loan assistance through partner banks</li>
          </ul>

          <h4>8. Contact Us</h4>
          <p>For payment-related queries:</p>
          <p><strong>Email:</strong> support@gencollege.in</p>
        </div>
      </section>
    </>
  );
}

export default PaymentPolicy;
